import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { TabNavBarComponent } from './tab-nav-bar.component';
import { TabNavBarLinkDirective } from './tab-nav-bar-link.directive';
import { TranslateModule } from '@itonics/ngx-translate-simple';

@NgModule({
  imports: [CommonModule, TranslateModule],
  providers: [],
  declarations: [TabNavBarLinkDirective, TabNavBarComponent],
  exports: [TabNavBarLinkDirective, TabNavBarComponent]
})
export class TabNavBar {}
